module.exports = __webpack_public_path__ + "img/esfj.7d78701c.png";